import type { RouteRecordRaw } from 'vue-router'

const projectRoutes: RouteRecordRaw[] = [
  {
    path: 'projects',
    component: () => import('@/views/project/ProjectLayout.vue'),
    children: [
      {
        path: '',
        name: 'projects',
        component: () => import('@/views/project/ProjectList.vue')
      },
      {
        path: 'risk-board',
        name: 'project-risk-board',
        component: () => import('@/views/project/RiskChangeBoard.vue')
      },
      {
        path: ':id',
        name: 'project-detail',
        component: () => import('@/views/project/ProjectDetail.vue')
      }
    ]
  }
]

export default projectRoutes
